import React from "react";
import { BRAND } from "../lib/brand";
import { useSeo, breadcrumbLd } from "../lib/seo";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      ["Overview", `${BRAND.name} respects your privacy. This policy explains what we collect and how we use it.`],
      ["Photos", "Photos you scan are tied to your account so you can track progress. You choose whether each FaceCard is public or private, and you can delete any scan at any time from your dashboard."],
      ["Account data", "We store your name, email and plan to operate your account. Authentication is handled via secure Google sign-in."],
      ["Payments", "Payments are processed by Stripe. We never see or store your full card details."],
      ["Your rights", "You can request deletion of your account and data at any time by contacting hello@selfiecheckup.com."],
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      ["Acceptance", `By using ${BRAND.name} you agree to these terms.`],
      ["Service", `${BRAND.name} provides AI-based facial-aesthetics analysis for self-improvement and entertainment. It is not a medical device and does not provide medical advice.`],
      ["Acceptable use", "Only upload photos of yourself or photos you have permission to use. Do not upload images of minors or illegal content."],
      ["Subscriptions", "Paid plans renew automatically until cancelled. You can cancel anytime from your dashboard and keep access until the end of your billing period."],
      ["Liability", `${BRAND.name} is provided 'as is'. Scores are estimates and should not be treated as definitive.`],
    ],
  },
};

export default function Legal({ kind = "privacy" }) {
  const c = CONTENT[kind];
  useSeo({
    title: c.title,
    description: `${c.title} for ${BRAND.name}.`,
    path: `/${kind}`,
    jsonLd: breadcrumbLd([{ name: "Home", path: "/" }, { name: c.title, path: `/${kind}` }]),
  });

  return (
    <div className="container max-w-3xl py-16">
      <h1 className="font-display text-5xl">{c.title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">Last updated {new Date().toLocaleDateString()}</p>
      <div className="mt-8 space-y-8">
        {c.body.map(([h, p]) => (
          <div key={h}>
            <h2 className="font-display text-2xl">{h}</h2>
            <p className="mt-2 text-muted-foreground">{p}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
